import { LinkButton } from '@cian/ui-kit/button';
import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';

import * as styles from './UserRelated.css';

interface IUserRelatedProps {
  userMenu: JSX.Element | null;
  utilities: JSX.Element;
  placeOfferLink: string | null;
  onPlaceOfferClick(): void;
  onAuthenticateClick(): void;
}

export const UserRelated: React.FC<IUserRelatedProps> = ({
  userMenu,
  utilities,
  placeOfferLink,
  onPlaceOfferClick,
  onAuthenticateClick,
}) => {
  const [returnUrl, setReturnUrl] = React.useState<string | null>(null);

  const handleAuthenticateClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      onAuthenticateClick();
    },
    [onAuthenticateClick],
  );

  const handleLocationChange = React.useCallback(() => {
    setReturnUrl(window.location.href);
  }, []);

  React.useEffect(() => {
    setReturnUrl(window.location.href);

    window.addEventListener('popstate', handleLocationChange);

    return () => window.removeEventListener('popstate', handleLocationChange);
  }, [handleLocationChange]);

  return (
    <div className={styles['container']}>
      <div className={styles['utilities']}>{utilities}</div>
      <Responsive tablet desktop>
        {placeOfferLink && (
          <div className={styles['place']}>
            <LinkButton href={placeOfferLink} size="XS" onClick={onPlaceOfferClick}>
              + Разместить объявление
            </LinkButton>
          </div>
        )}
        {userMenu || (
          <LinkButton
            href={`/authenticate/${returnUrl ? `?returnUrl=${returnUrl}` : ''}`}
            size="XS"
            theme="fill_secondary"
            onClick={handleAuthenticateClick}
          >
            Войти
          </LinkButton>
        )}
      </Responsive>
    </div>
  );
};
